import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=66bc1791&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=66bc1791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc1791",
  null
  
)

export default component.exports